import React, { ReactNode } from 'react'

interface ModalProps {
  show: boolean
  onClose: () => void
  title: string
  children: ReactNode
  footer?: ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

const Modal: React.FC<ModalProps> = ({ show, onClose, title, children, footer, size = 'lg' }) => {
  if (!show) return null

  const getModalSizeClass = () => {
    switch (size) {
      case 'sm':
        return 'modal-sm'
      case 'md':
        return 'modal-md'
      case 'lg':
        return 'modal-lg'
      case 'xl':
        return 'modal-xl'
      default:
        return 'modal-lg'
    }
  }

  return (
    <div className='modal' style={{ display: show ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className={`modal-dialog modal-dialog-centered ${getModalSizeClass()}`}>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>{title}</h5>
            <button type='button' className='close' onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <div className='modal-body'>
            {children}
          </div>
          {footer && (
            <div className='modal-footer'>
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Modal
